module.exports = __webpack_public_path__ + "img/canvasjs-logo.ad776b76.svg";